import { render, staticRenderFns } from "./managePartnerIndex.pug?vue&type=template&id=363f9849&scoped=true&lang=pug&"
import script from "./managePartnerIndex.ts?vue&type=script&lang=ts&"
export * from "./managePartnerIndex.ts?vue&type=script&lang=ts&"
import style0 from "./managePartnerIndex.scss?vue&type=style&index=0&id=363f9849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f9849",
  null
  
)

export default component.exports